import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  ActionLimitationEnhancement,
  WeaponLimitation,
  AbilityLimitation,
  SpellLimitation,
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import WeaponLimitInput from '@dndComponents/limitations/WeaponLimitInput';
import AbilityLimitInput from '@dndComponents/limitations/AbilityLimitInput';
import SpellLimitInput from '@dndComponents/limitations/SpellLimitInput';
import EnhancementModeBox from './EnhancementModeBox';

interface Props {
  header: string;
  value: ActionLimitationEnhancement;
  disabled: boolean;
  onChange: () => void;
}

// Adapted from TransformOptionInput's renderActionLimits, with a mode selector added
// and operating on a single ActionLimitationEnhancement (called once for char, once for creature).
export default function ActionLimitationEnhancementInput({
  header,
  value,
  disabled,
  onChange
}: Props) {
  const value_disabled = disabled || value.mode === "Leave";

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12} className="header centered">{ header }</Grid>
      <Grid size={12}>
        <EnhancementModeBox
          name="Mode"
          modes={["Leave","Replace","Add"]}
          value={value.mode}
          disabled={disabled}
          onChange={(changed) => {
            value.mode = changed as ActionLimitationEnhancement["mode"];
            onChange();
          }}
        />
      </Grid>
      <Grid size={12}>
        <SelectStringBox 
          name="Action Types"
          values={value.value.action_types} 
          options={["Unarmed Strike","Weapon","Ability","Spell"]}
          disabled={value_disabled}
          onChange={(changed: ("Unarmed Strike" | "Weapon" | "Ability" | "Spell")[]) => {
            value.value.action_types = changed;
            onChange();
          }}
        />
      </Grid>
      { value.value.action_types.includes("Weapon") && 
        <Grid size={12}>
          <WeaponLimitInput
            obj={value.value.weapon_limit}
            disabled={value_disabled}
            onChange={(changed: WeaponLimitation) => {
              value.value.weapon_limit = changed.clone();
              onChange();
            }}
          />
        </Grid>
      }
      { value.value.action_types.includes("Ability") && 
        <Grid size={12}>
          <AbilityLimitInput
            obj={value.value.ability_limit}
            disabled={value_disabled}
            onChange={(changed: AbilityLimitation) => {
              value.value.ability_limit = changed.clone();
              onChange();
            }}
          />
        </Grid>
      }
      { value.value.action_types.includes("Spell") && 
        <Grid size={12}>
          <SpellLimitInput
            obj={value.value.spell_limit}
            disabled={value_disabled}
            onChange={(changed: SpellLimitation) => {
              value.value.spell_limit = changed.clone();
              onChange();
            }}
          />
        </Grid>
      }
    </Grid>
  );
}
